// extracted by mini-css-extract-plugin
export default {"root":"CheckBox_root__J0tTi","checked":"CheckBox_checked__eqbjy","disabled":"CheckBox_disabled__1yN88"};